import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router';
import CaretLink from 'modules/Common/components/CaretLink';
import {convertCurrencyString} from "utils/CurrencyFormatting";
import moment from 'moment';
import {LocalTimeShort} from 'modules/Common/components/LocalDateTime';
import { raceStatusLabel, buildRuleFourString } from 'modules/HorseRacing/utils';
import HorseRacingRideSummaryTable from 'modules/HorseRacing/components/HorseRacingRideSummaryTable';
import HorseRacingFastRacecardRide from 'modules/HorseRacing/components/HorseRacingFastRacecardRide';
import HorseRacingFastRacecardExtraPlaces from 'modules/HorseRacing/components/HorseRacingFastRacecardExtraPlaces';
import { sortByOdds } from 'utils/compare';
import { filterRidesByStatus } from 'modules/HorseRacing/utils/rideFilter';
import { toSlug } from 'utils';
import PromoIcon from 'modules/Common/components/svg/PromoIcon';
import {titleToId} from 'utils/url-rewrite';
import {isBeforeOffStatus} from 'modules/HorseRacing/utils';
import RaceVideoPlayer from "./RaceVideoPlayer";
import _ from 'lodash';


require('./HorseRacingFastRacecard.scss');


const statusFlags = {
  FINISHED:   {after: true},
  PHOTOGRAPH: {after: true},
  RESULT:     {after: true, positions: true},
  WEIGHEDIN:  {after: true, positions: true, full: true}
};


function checkStatus(status, flag) {
  const {
    [status]: {
      [flag]: result = false
    } = {}
  } = statusFlags;

  return result;
}

function numberSort(...numbers) {
  const [a, b] = numbers.map(n => (parseInt(n) || 0));
  return a - b;
}

export default class HorseRacingFastRacecard extends Component {
  static propTypes = {
    non_runners: PropTypes.arrayOf(PropTypes.number),
    withdrawn: PropTypes.arrayOf(PropTypes.number),
    top_horses: PropTypes.arrayOf(PropTypes.object),
    extra_place_horses: PropTypes.arrayOf(PropTypes.object),
    unplaced_favourite: PropTypes.arrayOf(PropTypes.object),
    winning_trainers: PropTypes.array,
    winning_jockeys: PropTypes.array,
    number_of_placed_rides: PropTypes.number,
    runners: PropTypes.number,
    courseName: PropTypes.string,
    status: PropTypes.string,
    time: PropTypes.string,
    distances: PropTypes.string,
    exacta_win: PropTypes.string,
    place_win: PropTypes.string,
    straight_forecast: PropTypes.string,
    swingers: PropTypes.string,
    tote_win: PropTypes.string,
    tricast: PropTypes.string,
    trifecta: PropTypes.string,
    slug: PropTypes.string,
    meetingMode: PropTypes.bool,
    deductions: PropTypes.array,
    stewards: PropTypes.string,
    race: PropTypes.object,
    videos: PropTypes.array,
    each_way: PropTypes.object,
    promotions: PropTypes.object
  };

  constructor() {
    super();
    this.state = {playerOpen: false};
  }

  render() {
    const {
      top_horses: topHorses = [],
      extra_place_horses: extraPlaceHorses = [],
      unplaced_favourite: unplacedFavourite = [],
      time: raceTime,
      courseName: courseName,
      slug: racecardSlug,
      status: raceStatus,
      meetingMode = false,
      each_way: eachWay = null,
      race: {
        race_summary: {
          promotion: {
            image: promotionImage,
            redirect_url
          } = {}
        } = {}
      } = {}
    } = this.props;

    const today = moment().format("YYYY-MM-DD");
    const favToken = favHorsesToken(topHorses, unplacedFavourite);
    const isAfter = checkStatus(raceStatus, "after");
    const showRides = checkStatus(raceStatus, "positions") && topHorses.length > 0;

    const togglePlayer = () => {
      this.setState(prevState => ({playerOpen: !prevState.playerOpen}));
    };

    let linkType;

    if (checkStatus(raceStatus, "full")) {
      linkType = "full";
    }
    else if (isAfter) {
      linkType = "disabled";
    }
    else {
      linkType = "card";
    }

    function cardUrl(slug = "") {
      return `/racing/racecards/${slug}`;
    }

    function resultUrl(slug = "") {
      // Slug comes from the API, which is why it needs (a) being super careful to cast to string and (b) altering to a result slug
      return `/racing/results/${`${slug}`.replace("/racecard/", "/")}`;
    }

    const showPromo = !!(redirect_url && isBeforeOffStatus(raceStatus));

    return (
      <div className="fast-racecard-item">
        <div className="fast-racecard-header">
          <div className="fast-racecard-header-race" id={titleToId(courseName)}>
            {!!raceTime &&
              <LocalTimeShort iso={`${today}T${raceTime}Z`} />} {!meetingMode && (courseName ? courseName : "Unknown")}
          </div>
          {showPromo && <div className="hr-meeting-race-promo">
              <span className="hr-meeting-race-promo-icon">
                <PromoIcon type={promotionImage}/>
              </span>
            </div>}
          <div className={"fast-racecard-header-fulllink" + (_.get(this, "props.videos.length") > 0 ? " button-with-radius" : "")}>
            {(linkType == "card") && <CaretLink to={cardUrl(racecardSlug)}>Race card</CaretLink>}
            {(linkType == "full") &&
            <React.Fragment>
              <Link className={"fast-racecard-header-fulllink-btn" + (_.get(this, "props.videos.length") > 0 ? "  button-without-radius" : "")} to={resultUrl(racecardSlug)}>Full Result</Link>
              {_.get(this, "props.videos.length") > 0 && <Link className="fast-racecard-header-fulllink-btn-video" to={resultUrl(racecardSlug)}></Link>}
            </React.Fragment>
            }
            {(linkType == "disabled") && <span className="fast-racecard-header-fulllink-btn without-video">Full Result</span>}
          </div>
        </div>
        {showRides && topFinishedRides(topHorses, extraPlaceHorses, favToken, eachWay)}
        {linkType == "card" && preRaceDetails(this.props)}
        {linkType != "card" && postRaceDetails(this.state, this.props, isAfter, favToken, togglePlayer, linkType)}
      </div>
    );
  }
}

function topFinishedRides(topHorses, extraPlaceHorses, favToken, eachWay) {
  return (
    <div>
      {topHorses.map(ride => <HorseRacingFastRacecardRide key={ride.horse_reference.id} ride={ride} favToken={favToken} />)}
      {(extraPlaceHorses.length > 0) && <HorseRacingFastRacecardExtraPlaces rides={extraPlaceHorses} places={eachWay.places} favToken={favToken} />}
    </div>
  );
}

function preRaceDetails(raceDetails) {
  const {
    race: {
      race_summary: {
        race_summary_reference: {
          external_reference: [{
            value: raceExternalId
          } = {}] = []
        } = {},
        distance
      } = {},
      race_summary,
      prizes: {
        prize
      } = {},
      rides,
      number_of_placed_rides,
      each_way,
      market_suspended,
      fixture,
      last_years_winners: [{
        horse: {
          name: lastYearWinner
        } = {},
        meeting_summary: {
          date: previousResultDate,
          course: {
            name: previousResultCourseName
          } = {}
        } = {},
        race_summary: {
          race_summary_reference: {
            id: previousResultRaceId
          } = {},
          name: previousResultRaceName
        } = {}
      } = {}] = []
    } = {},
    runners,
    status: raceStatus,
    stewards
  } = raceDetails;

  function rideSummary() {
    if (rides) {
      const topRunners = filterRidesByStatus(rides, "RUNNER").sort(sortByOdds).slice(0, number_of_placed_rides);
      return <HorseRacingRideSummaryTable runners={topRunners} raceExternalId={raceExternalId} raceSummary={race_summary} eachWay={each_way}
            suspended={market_suspended} fixture={fixture}/>
    } else {
      return <div className="no-rides-available"/>
    }
  }

  function topPrize() {
    const [topPrize] = prize.filter(p => p.position == 1).map(p => convertCurrencyString(p.prize));
    return <OptionalData className="fast-racecard-always-open" value={topPrize}>Winner:</OptionalData>
  }

  return (
    <div className="fast-result-pre-race">
      { rideSummary() }
      <ul className="fast-racecard-content">
        <OptionalData className="fast-racecard-always-open" value={distance}>Distance:</OptionalData>
        { prize && topPrize() }
        <OptionalData className="fast-racecard-always-open" value={runners}>Runners:</OptionalData>
        <OptionalData className="fast-racecard-always-open" value={lastYearWinner}>Last Year's Winner:</OptionalData>
        { previousResultDate && previousResultCourseName && previousResultRaceId && previousResultRaceName &&
          <CaretLink to={`/racing/results/${previousResultDate}/${toSlug(previousResultCourseName)}/${previousResultRaceId}/${toSlug(previousResultRaceName)}`}>Last Year's Result</CaretLink>
        }
        {raceStatus &&
          <li className="fast-result-status">
            <span className="fast-result-status-label">{raceStatusLabel(raceStatus, stewards)}</span>
          </li>
        }
      </ul>
    </div>
  );
}

function postRaceDetails(state, raceDetails, isAfter, favToken, togglePlayer, linkType) {

  const {
    unplaced_favourite: unplacedFavourite = [],
    status: raceStatus,
    winning_trainers: winningTrainers = [],
    winning_jockeys: winningJockeys = [],
    runners: runners,
    non_runners: nonRunners = [],
    withdrawn: withdrawn = [],
    distances,
    tote_win: toteWin,
    place_win: placeWin,
    exacta_win: exactaWin,
    trifecta,
    straight_forecast: straightForecast,
    tricast,
    swingers,
    deductions = [],
    stewards,
    videos: videos = []
  } = raceDetails;

  return (
    <div className="fast-racecard-content-wrapper">
    <ul className="fast-racecard-content">
      { winningTrainers.map((t, i, { length }) =>
        <OptionalData key={ i }
          className={ `fast-racecard-content-top fast-racecard-always-open${i == length - 1 && !winningJockeys.length ? ' fast-racecard-content-spaced' : ''}` }
          value={ t.name }>{ !i && 'Winning Trainer:' }</OptionalData>
      ) }
      { winningJockeys.map((j, i, { length }) =>
        <OptionalData key={ i }
          className={ `fast-racecard-content-top fast-racecard-always-open${i == length - 1 ? ' fast-racecard-content-spaced' : ''}` }
          value={ j.name }>{ !i && 'Winning Jockey:' }</OptionalData>
      ) }
      {!!runners &&
        <li className="fast-racecard-always-open">
          <span className="fast-racecard-content-label">Runners:</span>
          <span className="fast-racecard-content-value">{runners} {isAfter && "ran"}</span>
        </li>}
      {!!nonRunners.length &&
        <li className="fast-racecard-always-open">
          <span className="fast-racecard-content-label">Non-Runners:</span>
          <span className="fast-racecard-content-value">{nonRunners.sort(numberSort).join(", ")}</span>
        </li>}
      {deductions.map((deduction, index) =>
        <li key={index}>
          <span className="fast-racecard-content-label">{!index && 'Rule 4:'}</span>
          <span className="fast-racecard-content-value">{buildRuleFourString(deduction)}</span>
        </li>
      ) }
      {withdrawn.length > 0 &&
        <li>
          <span className="fast-racecard-content-label">Withdrawn:</span>
          <span className="fast-racecard-content-value">{withdrawn.sort(numberSort).join(", ")}</span>
        </li>}
      {unplacedFavourite.length > 0 &&
        <li>
          <span className="fast-racecard-content-label">Unpl.Fav:</span>
          <span className="fast-racecard-content-value">
            {unplacedFavourite.map(({
              horse_name: horseName,
              odds: odds
            }, index) => (
              <span key={index} className="fast-results-unplaced">{ horseName } { odds } { favToken.toUpperCase() }</span>
            ))}
          </span>
        </li>}
      <OptionalData className="fast-racecard-always-open" value={distances}>Distances:</OptionalData>
      <OptionalData value={convertCurrencyString(toteWin)}>Tote Win:</OptionalData>
      <OptionalData value={convertCurrencyString(placeWin)}>Pl:</OptionalData>
      <OptionalData value={convertCurrencyString(exactaWin)}>EX:</OptionalData>
      <OptionalData value={convertCurrencyString(trifecta)}>Trifecta:</OptionalData>
      <OptionalData value={convertCurrencyString(straightForecast)}>SF:</OptionalData>
      <OptionalData value={convertCurrencyString(tricast)}>Tricast:</OptionalData>
      <OptionalData value={convertCurrencyString(swingers)}>Swingers:</OptionalData>
      {raceStatus &&
        <li className="fast-result-status">
          <span className="fast-result-status-label">{raceStatusLabel(raceStatus, stewards)}</span>
        </li>}
    </ul>
    {videos.length > 0 &&
      <div className="fast-racecard-video">
        {state.playerOpen &&
        <RaceVideoPlayer videos={videos} showLoginBenefits={false}/>
        }

        {!state.playerOpen &&
        <div className={"fast-racecard-video-banner"} onClick={togglePlayer}>
          <div className="fast-racecard-video-background"></div>
          <img className="fast-racecard-video-play-button" src="/img/has-video-icon.svg"/>
          <div className="fast-racecard-video-copy">Replay now available for this race!</div>
        </div>
        }
      </div>
      }
    </div>
  );
}

function OptionalData(props) {
  return props.value
       ? (
           <li className={props.className}>
             <span className="fast-racecard-content-label">{props.children}</span>
             <span className="fast-racecard-content-value">{props.value}</span>
           </li>
         )
       : null;
}

OptionalData.propTypes = {
  className: PropTypes.string,
  value: PropTypes.any,
  children: PropTypes.node
};

function countFavHorses(array) {
  var result = 0;
  if (array) {
    for (var i = 0; i < array.length; i++) {
      if (array[i].favourite === true) {
        result++;
      }
    }
  }
  return result;
}

function favHorsesToken(arrayTop, arrayUnfav) {
  const sum = countFavHorses(arrayTop) + countFavHorses(arrayUnfav);
  if (sum == 1) {
    return "f";
  } else if (sum >= 2) {
    return "j";
  }
  return "";
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingFastRacecard.js